import { cn } from '@/lib/shadcn/lib/utils';

export function Max({ className }: { className?: string }) {
  return (
    <svg
      className={cn('size-full', className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9199 0.800171C16.4356 0.800171 20.742 5.27689 20.7432 10.7562L20.7314 11.2601C20.4869 16.4444 16.221 20.5837 10.9727 20.6117H10.9688C10.0341 20.6117 9.27987 20.5445 8.5498 20.3109C8.00428 20.1363 7.50282 19.8786 6.96875 19.5316C6.34375 20.0416 5.51086 20.4222 4.76562 20.5795C4.26711 20.6846 3.68527 20.7182 3.17383 20.5219C2.90566 20.4189 2.64717 20.2474 2.44922 19.9857C2.25051 19.723 2.14631 19.4133 2.12012 19.0873L2.11816 19.0551V19.0238C2.11816 17.956 1.88368 17.0469 1.58496 15.9486L1.58398 15.9418C1.22706 14.5846 0.799808 12.9973 0.799805 10.7103C0.799805 5.03788 5.4561 0.800303 10.9199 0.800171ZM10.8369 6.88708C8.92151 6.86492 7.38879 8.20126 7.02832 10.4681C6.87032 11.466 6.93044 12.5989 7.0957 13.4974C7.16008 13.8474 7.23688 14.1433 7.31445 14.3695C7.47014 14.2463 7.63224 14.1015 7.76562 13.9681L8.2373 13.4965L8.78613 13.8754C9.32529 14.2478 9.95266 14.4727 10.6055 14.5277C12.7135 14.6236 14.5123 13.0198 14.6582 10.9144C14.733 8.80332 13.1078 7.01775 10.9971 6.89685L10.8369 6.88708Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
